// DeviceSupportToolTip component shows the user which device is supported (only when one device is supported)
import React from 'react';
import TooltipPopover from 'components/TooltipPopover';

interface DeviceSupportTooltipProps {
  isMobileSupported: boolean;
  isDesktopSupported: boolean;
  view: 'mobile' | 'desktop';
}

const DeviceSupportTooltip = ({
  isMobileSupported,
  isDesktopSupported,
  view,
}: DeviceSupportTooltipProps) => {
  // When both devices are supported do not render this component, Mobile/Desktop toggle will be rendered instead
  if (isMobileSupported === isDesktopSupported) return null;

  // Display the supported device in case of single device support to show user data belongs to which device type (Mobile or Desktop)
  return (
    <TooltipPopover
      content={`competitive_intelligence_page.device.${view}`}
      type="dashed"
      side="top"
    >
      <span className={'text-primarygray ml-2'}>
        {view === 'mobile' ? 'Mobile' : 'Desktop'}
      </span>
    </TooltipPopover>
  );
};

export default DeviceSupportTooltip;
